<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">系统设置</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>节点配置</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <Creat></Creat>
        <el-button @click="handleSearch" type="primary">搜索</el-button>
      </div>
      <div>
        <List></List>
        <PageNation
          :total="totalCount"
          :size="size"
          :page="page"
          @pageChanged="handlePageChanged($event)"
        ></PageNation>
      </div>
    </el-card>
  </div>
</template>

<script>
import "./store";
import { mapActions, mapState } from "vuex";
import Creat from "./components/creat";
import List from "./components/list";
import PageNation from "../../../components/pagination";

export default {
  name: "nodeConfigStore",
  data() {
    return {
      dialogVisible: false,
      options: [
        {
          value: "zh",
          label: "中文",
        },
      ],
      total: "",
      page: 1,
      size: 10,
      obj: {},
    };
  },
  components: {
    Creat,
    List,
    PageNation,
  },

  computed: {
    ...mapState("nodeConfigStore", ["codelist", "totalCount"]),
  },

  methods: {
    ...mapActions("nodeConfigStore", ["getlist", "getUrlList"]),
    closeDialog() {},
    getData() {
      this.getUrlList({
        page: 1,
        size: this.size,
      });
    },
    async handleSearch() {
      this.getUrlList({
        page: 1,
        size: this.size,
      });
    },
    handlePageChanged(e) {
      this.page = e.page;
      this.size = e.size;
      this.obj = { ...this.obj, ...e };
      this.getUrlList({ ...this.obj });
    },
  },
};
</script>

<style lang="less" scoped></style>
